import api from './api';
import endpoints from './endpoints';

// 新增：创建找队友帖子
const createFriendPost = async (data) => {
  try {
    console.log('创建找队友帖子，数据:', data);

    // 构建v2 API格式的请求数据
    const type = data.type || "article";
    // 构建 fields，如果 type 为 biography，则不添加 category 字段
    const fields = {
      title: data.prompt || data.title, // v1的prompt映射到v2的title
      body_text: data.response || data.content, // v1的response映射到v2的body_text
      tags: data.topics || [], // v1的topics映射到v2的tags
      status: data.status || 'draft',
    };

    if (type !== "biography") {
      fields.category = "post";
    }

    const requestData = {
      type,
      fields
    };

    // 只有当 cover_image 是有效 UUID 时才添加
    const coverImage = data.thumb || data.cover_image;
    if (coverImage) {
      let coverImageId = null;

      // 如果是字符串，直接使用
      if (typeof coverImage === 'string') {
        const trimmed = coverImage.trim();
        if (trimmed !== '' && trimmed !== 'undefined' && trimmed !== 'null') {
          coverImageId = trimmed;
        }
      }
      // 如果是上传文件对象，提取 id 字段
      else if (coverImage && typeof coverImage === 'object') {
        coverImageId = coverImage.id || coverImage.file_id || coverImage.uid;
      }

      // 验证是否为有效UUID并添加
      if (coverImageId && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(coverImageId)) {
        requestData.fields.cover_image = coverImageId;
      }
    }

    // 只有当 attachments 包含有效 UUID 时才添加
    if (data.attachments && Array.isArray(data.attachments) && data.attachments.length > 0) {
      // 过滤出有效的 UUID（36字符，包含连字符的格式）
      const validAttachments = data.attachments.filter(attachment => {
        if (typeof attachment === 'string') {
          // 简单的 UUID 格式检查：36 字符，8-4-4-4-12 模式
          return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(attachment);
        }
        // 如果 attachment 是对象，可能需要提取 file_id 或 id
        if (attachment && typeof attachment === 'object') {
          const id = attachment.file_id || attachment.id;
          return id && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
        }
        return false;
      }).map(attachment => {
        // 如果是字符串直接返回，如果是对象则提取 UUID
        return typeof attachment === 'string' ? attachment : (attachment.file_id || attachment.id);
      });

      if (validAttachments.length > 0) {
        requestData.fields.attachments = validAttachments;
      }
    }

    console.log('发送的v2请求数据:', requestData);
    const response = await api.post('/contents', requestData);
    console.log('创建找队友帖子成功:', response);
    return response;
  } catch (error) {
    console.error('创建找队友帖子失败:', error);
    throw error;
  }
};

/**
 * 获取找队友列表 (API规范: POST /v1/syntrust/post/search)
 * @param {Object} params - 查询参数
 * @returns {Promise} - 找队友列表数据
 */
const getFriends = async (params = {}) => {
  try {
    console.log('获取找队友列表，参数:', params);

    // 构建符合API规范的请求参数
    const requestParams = {
      scope: params.scope || 'square', // 找队友类型
      user_id: params.user_id || '', // 用户ID
      pagination: params.pagination || {
        page: 1,
        per_page: 20,
      },
    };

    // 添加筛选条件
    if (params.filter) {
      requestParams.filter = params.filter;
    }

    // 添加排序条件
    if (params.sort) {
      requestParams.sort = params.sort;
    }

    console.log('发送的请求参数:', requestParams);

    // V2 API: 使用统一内容API搜索找队友帖子
    const v2RequestParams = {
      type: 'article',
      category: 'post',
      scope: 'square',
      tags: ['找队友'],
      ...requestParams.filter,
      page: requestParams.pagination?.page || 1,
      limit: requestParams.pagination?.per_page || 20,
    };

    console.log('发送V2 API请求参数:', v2RequestParams);

    const response = await api.post(
      endpoints.friends.search, // 使用统一内容搜索端点
      v2RequestParams
    );

    console.log('V2 API原始响应:', response);

    // api.js已经提取了data层，所以response直接是{metadata, contents}
    return {
      pagination: {
        total: response.metadata?.total || 0,
        page: response.metadata?.page || 1,
        per_page: response.metadata?.per_page || 20,
      },
      contents: response.contents || [],
    };
  } catch (error) {
    console.error('获取找队友列表失败:', error);
    throw error;
  }
};

/**
 * 获取找队友帖子详情 (V2 API: GET /api/v2/contents/{id})
 * @param {string} id - 帖子ID
 * @returns {Promise} - 帖子详情数据
 */
const getRecruitPostDetail = async (id) => {
  try {
    console.log('获取帖子详情，ID:', id);
    // V2 API: 使用统一内容API获取详情
    const response = await api.get(endpoints.recruit.detail(id));
    console.log('V2 API详情响应:', response);

    // api.js已经提取了data层，所以response就是content对象
    // 但需要添加一些v1兼容字段便于现有UI渲染
    const enrichedResponse = {
      ...response,
      // 兼容v1格式，从v2字段映射
      prompt: response.fields?.title || '',
      response: response.fields?.body_text || '',
      tags: response.fields?.tags || [],
      thumb: response.fields?.cover_image ? {
        url: `/api/v2/contents/${response.fields.cover_image}/file`,
        id: response.fields.cover_image
      } : null,
      attachments: response.fields?.attachments?.map(attachmentId => ({
        id: attachmentId,
        url: `/api/v2/contents/${attachmentId}/file`,
        content_type: 'unknown', // 需要从attachment获取具体类型
      })) || [],
      // 互动数据
      like_count: response.interactions?.like_count || 0,
      comment_count: response.interactions?.comment_count || 0,
      share_count: response.interactions?.share_count || 0,
      // TODO: 需要从用户API获取作者信息
      creator: {
        id: response.author_id,
        nickname: 'Unknown', // 临时值，需要从用户API获取
        avatar: null,
      },
      // 用户交互状态 - 需要单独API获取
      is_liked: response.is_liked || false, 
      is_favorited: false, // TODO: 需要获取用户收藏状态
      scope: 'recruit', // 兼容字段
    };

    console.log('处理后的详情数据:', enrichedResponse);
    return enrichedResponse;
  } catch (error) {
    console.error('获取帖子详情失败:', error);
    throw error;
  }
};

// 新增：获取附件预览图片url
const getAttachmentPreviewUrl = (id) => {
  if (!id) return '';
  return `/attachments/${id}/download`;
};

const toggleLike = async (postId) => {
  return api.post(endpoints.like.toggle(postId));
};

const toggleFavorite = async (postId) => {
  return api.post(endpoints.favorite.toggle(postId));
};

/**
 * 删除找队友帖子 (直接调用v2 API: DELETE /api/v2/contents/{id})
 * @param {string} id - 帖子ID
 * @returns {Promise} - 删除结果
 */
const deleteRecruitPost = async (id) => {
  try {
    console.log('删除帖子，ID:', id);
    const response = await api.delete(`/contents/${id}`);
    console.log('删除帖子成功:', response);
    return response;
  } catch (error) {
    console.error('删除帖子失败:', error);
    throw error;
  }
};

/**
 * 搜索内容 (使用统一内容搜索API)
 * @param {Object} searchParams - 搜索参数
 * @returns {Promise}
 */
const searchContents = async (searchParams = {}, options = {}) => {
  try {
    console.log('searchContents searchParams', searchParams);
    const response = await api.post(endpoints.friends.search, searchParams, '', '', options);
    return response;
  } catch (error) {
    console.error('搜索内容失败:', error);
    throw error;
  }
};

const friendService = {
  createFriendPost,
  getFriends,
  searchContents,
  getRecruitPostDetail,
  getAttachmentPreviewUrl,
  toggleLike,
  toggleFavorite,
  deleteRecruitPost,
};

export default friendService;
